const product = {
  namespaced:true,
  state: () => ({
    selectedProduct: []
  }),
  mutations:{
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    },
  }
}

export default product